var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-typing-message"},[_c('span',[_vm._v("User is typing "+_vm._s(_vm.dots))])])
}
var staticRenderFns = []

export { render, staticRenderFns }